import "./print.css"
import { useEffect, useState } from "react"
import { useLocations } from "../../hooks/locations"
import { Table, Thead, Tbody, Tr, Th, Td } from "@chakra-ui/react"
import EmptyState from "../Common/EmptyState"

const getSortedTable = (table) => {
  let tmp = [...table]
  console.log(tmp)
  tmp.sort((a, b) => {
    return a.zone > b.zone
  })
  return tmp
}

const DataTable = ({ columns, rows }) => {
  return (
    <Table variant="simple" size="md" id="zonePrintTarget">
      <Thead>
        <Tr>
          {Object.entries(columns).map(
            ([field, { textAlign = "left", label, expand }]) => (
              <Th
                key={field}
                textAlign={textAlign}
                color="gray.600"
                userSelect="none"
                w={expand ? "full" : "auto"}
              >
                {label}
              </Th>
            )
          )}
        </Tr>
      </Thead>
      <Tbody>
        {rows.map((row) => (
          <Tr key={row.id} _hover={{ bg: "gray.100" }}>
            {Object.entries(columns).map(
              ([field, { textAlign = "left", render, expand }]) => (
                <Td
                  key={field}
                  textAlign={textAlign}
                  w={expand ? "full" : "auto"}
                  whiteSpace="nowrap"
                >
                  {render ? render(row) : row[field]}
                </Td>
              )
            )}
          </Tr>
        ))}
      </Tbody>
    </Table>
  )
}

const ZonePrinter = ({ linkId, orders }) => {
  const [ordersWithZone, setOrdersWithZone] = useState(orders)
  const { locations } = useLocations()

  useEffect(
    () =>
      setOrdersWithZone([
        ...orders.map((order) => ({
          ...order,
          zone: locations?.find((location) => location.id === order.city)?.zone,
        })),
      ]),
    [orders, locations]
  )

  return orders?.length ? (
    <DataTable
      rows={getSortedTable(ordersWithZone)}
      columns={{
        orderId: { label: "N." },
        zone: { label: "Zona" },
        cityName: { label: "Consegna" },
        address: {
          label: "Indirizzo",
          render: (item) => (item.address ? item.address : "Ritiro"),
        },
        fullName: {
          label: "Cliente",
          render: (item) => `${item.surname} ${item.name}`,
        },
      }}
    />
  ) : (
    <EmptyState text="Nessun ordine" />
  )
}

export default ZonePrinter
